import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home/Home.vue';

const ExpersRead = () => import('@/views/expers-read/ExpersRead.vue')
const ExpertsDetail = () => import('@/views/experts-detail/ExpertsDetail.vue')
const HospitalNotice = () => import('@/views/hospital-notice/HospitalNotice.vue')
const HealthAdvice = () => import('@/views/health-advice/HealthAdvice.vue')
const Disclaimer = () => import('@/views/disclaimer/Disclaimer.vue')
const AcademicLiteratureList = () => import('@/views/academicLiteratureList/index.vue')
const AcademicLiteratureDetail = () => import('@/views/academicLiteratureDetail/index.vue')
const Literaturehome = () => import('@/views/literature-home/LiteratureHome.vue')

// import ExpersRead from '@/views/expers-read/ExpersRead.vue'
// import ExpertsDetail from '@/views/experts-detail/ExpertsDetail.vue'
// import HospitalNotice from '@/views/hospital-notice/HospitalNotice.vue'
// import HealthAdvice from '@/views/health-advice/HealthAdvice.vue'


Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		redirect:'/index',
	},
	{
		path: '/index',
		name: 'Home',
		component: Home
	},
	{
		path: '/expersread',
		name: 'ExpersRead',
		component: ExpersRead
	},
	{
		path: '/agreement',
		name: 'Disclaimer',
		component: Disclaimer
	},
	{
		path: '/expertsdetail',
		name: 'ExpertsDetail',
		component: ExpertsDetail
	},
	{
		path: '/hospitalnotice',
		name: 'HospitalNotice',
		component: HospitalNotice
	},
	{
		path: '/healthadvice',
		name: 'HealthAdvice',
		component: HealthAdvice
	},
	{
		path: '/academicLiteratureList',
		name:'AcademicLiteratureList',
		component:AcademicLiteratureList
	},
	{
		path: '/academicLiteratureDetail',
		name:'AcademicLiteratureDetail',
		component:AcademicLiteratureDetail
	},
	{
		path: '/literaturehome',
		name: 'Literaturehome',
		component: Literaturehome
	},
];

const router = new VueRouter({
	routes
});

export default router;
